import { Suspense, memo, useMemo, LazyExoticComponent, ComponentType, type VFC } from 'react'
import { getExposedNamespace, lazyImportComponent } from '../../framework/microApps'
import { useRootElementClassNameLayoutEffect } from '../common/appEffects'
import NavErrorBoundary from '../common/NavErrorBoundary'
import type { StateRef, StoreState } from '../../framework/stateTypes'

type KeyComp = [string, LazyExoticComponent<ComponentType<any>>]
const RightSidebar: VFC<{ stateRef: StateRef, state: StoreState }> = ({ stateRef, state }) => {
  const ns = getExposedNamespace('scm_main_layout.content_right')
  const Components = useMemo<KeyComp[] | undefined>(() => ns && Object.keys(ns).map((key) => {
    const Comp = lazyImportComponent('scm_main_layout.content_right', key)
    return [key, Comp]
  }), [ns])
  const hasComponents = Components?.length

  useRootElementClassNameLayoutEffect(hasComponents ? 'scm-with-content-right' : '')

  if (!hasComponents) {
    return null
  }

  const panels = Components.map(([key, Comp]) => (
    <NavErrorBoundary key={key} context={`scm_main_layout.content_right.${key}`}>
      <Suspense fallback={null}>
        <Comp stateRef={stateRef} state={state} />
      </Suspense>
    </NavErrorBoundary>
  ))
  return <>{panels}</>
}

export default memo(RightSidebar)
